// @ts-nocheck
import { useNavigate } from "react-router-dom";
import { Popup, Space, Button, Toast, CenterPopup } from "antd-mobile";
import "./index.css";
import { useTranslation } from "react-i18next";
import { getText } from "../../../../utils/util";
import { useEffect, useState } from "react";
import Search from "../../../../components/search";
import { imageConfig } from "../../../../config/config";

export default function OrderPopup({
  nowTab,
  type,
  setType,
  isShowOrder,
  setIsShowOrder,
  coinListData,
  index,
  ctmarketlist,
  userInfo,
  buyCoin,
  hysetInfo,
  setyqsy,
  leverSet1,
  leverSet2,
  leverage,
}) {
  leverSet1.sort((a, b) => a.num - b.num);
  leverSet2.sort((a, b) => a.num - b.num);
  leverage.sort((a, b) => a.num - b.num);
  const [zyNum, setzyNum] = useState(0);
  const [type1, setType1] = useState(0);
  const [zsNum, setzsNum] = useState(0);
  const [type2, setType2] = useState(0);
  const [leverageIndex, setLeverageIndex] = useState(1);
  const [num, setNum] = useState("");
  const [bsnum, setbsNum] = useState("");
  const [lossPrice, setlossPrice] = useState("");
  const [winPrice, setwinPrice] = useState("");
  const [boomPrice, setboomPrice] = useState(0);
  let [minNum, setminNum] = useState(1000);
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [isUse, setIsUse] = useState(true);
  //
  const [visible, setVisible] = useState(false);

  //止盈
  const getLeverSet2Nodes = () => {
    const nodes = [];
    for (let index = 0; index < leverSet2.length; index++) {
      const element = leverSet2[index];
      nodes.push(
        <div
          key={index}
          className={`px-3 py-2 rounded-md text-center text-sm ${
            type1 === index ? "bg-primary text-white" : "bg-neutral-700 text-neutral-300"
          }`}
          onClick={() => {
            setType1(index);
            setzyNum(element.num);
          }}
        >
          {element.num}%
        </div>
      );
    }
    return nodes;
  };

  //止损
  const getLeverSet1Nodes = () => {
    const nodes = [];
    for (let index = 0; index < leverSet1.length; index++) {
      const element = leverSet1[index];
      nodes.push(
        <div
          key={index}
          className={`px-3 py-2 rounded-md text-center text-sm ${
            type2 === index ? "bg-primary text-white" : "bg-neutral-700 text-neutral-300"
          }`}
          onClick={() => {
            setType2(index);
            setzsNum(element.num);
          }}
        >
          {element.num}%
        </div>
      );
    }
    return nodes;
  };

  //杠杆倍数
  const getLeverageNodes = () => {
    const nodes = [];
    for (let index = 0; index < leverage.length; index++) {
      const element = leverage[index];
      nodes.push(
        <div
          key={index}
          className={`px-3 py-2 rounded-md text-center text-sm ${
            leverageIndex === index ? "bg-primary text-white" : "bg-neutral-700 text-neutral-300"
          }`}
          onClick={() => {
            setLeverageIndex(index);
            setbsNum(element.num);
            setzsNum(0);
            setzyNum(0);
            setType1(0);
            setType2(0);
          }}
        >
          {element.num}X
        </div>
      );
    }
    return nodes;
  };

  // USDT->RMB
  const getchangeNum = () => {
    if (!num) {
      return 0;
    }
    const rate = hysetInfo?.usdtcnyrate;
    const element = num * rate || 0;
    return element.toFixed(4);
  };

  // 爆仓价
  const getboomPrice = () => {
    const openPrice = coinListData[nowTab]?.close;
    let price = 0;
    if (type == 1) {
      price = openPrice * (1 - 1 / bsnum + 0.005);
    }
    if (type == 2) {
      price = openPrice * (1 + 1 / bsnum - 0.005);
    }
    setboomPrice(price.toFixed(4));
  };

  // 止盈价
  const getWinPrice = () => {
    const openPrice = coinListData[nowTab]?.close;
    let price = 0;
    if (type == 1) {
      price = openPrice * (1 + zyNum / 100);
    }
    if (type == 2) {
      price = openPrice * (1 - zyNum / 100);
    }
    return price.toFixed(4);
  };

  // 止损价
  const getLossPrice = () => {
    const openPrice = coinListData[nowTab]?.close;
    let price = 0;
    if (type == 1) {
      price = openPrice * (1 - zsNum / 100);
    }
    if (type == 2) {
      price = openPrice * (1 + zsNum / 100);
    }
    return price.toFixed(4);
  };

  useEffect(() => {
    if (bsnum && zsNum && zyNum) {
      setlossPrice(getLossPrice());
      setwinPrice(getWinPrice());
      getboomPrice();
    }
  }, [zsNum, zyNum, bsnum, type]);

  useEffect(() => {
    if (isShowOrder) {
      setminNum(1); // 最小值
      setzyNum(leverSet2[0].num);
      setzsNum(leverSet1[0].num);
      setbsNum(leverage[0].num);
      setType1(0);
      setType2(0);
      setLeverageIndex(0);
      setNum(10);
    }
  }, [isShowOrder]);

  return (
    <Popup
      visible={isShowOrder}
      onMaskClick={() => {
        setIsShowOrder(false);
      }}
      bodyStyle={{
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        backgroundColor: "#1f2937",
        color: "#fff",
        minHeight: "60vh",
      }}
    >
      <div className="bg-neutral-800 min-h-[60vh]">
        <div className="flex justify-between items-center p-4 border-b border-neutral-700">
          <div className="text-lg font-medium text-white">
            {type === 1
              ? translate(getText("看漲"))
              : translate(getText("看跌"))}
            {nowTab.toUpperCase() + "/USDT"}
          </div>
          <div
            className="text-neutral-400 cursor-pointer"
            onClick={() => setIsShowOrder(false)}
          >
            ✕
          </div>
        </div>

        <div className="p-4">
          <div className="mb-4">
            <div className="text-neutral-400 text-sm mb-2">
              {translate(getText("最新價格"))}
            </div>
            <div className="text-xl font-bold text-white">
              {coinListData[nowTab]?.close} USDT
            </div>
          </div>

          <div className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <div className="text-neutral-400 text-sm">
                {translate(getText("保证金"))} (USDT)
              </div>
              <div className="text-neutral-400 text-sm">
                {translate(getText("可用"))}:{" "}
                {userInfo?.balance?.usdt_available || "0.0000"}
              </div>
            </div>
            <div className="flex items-center bg-neutral-700 rounded-lg p-2 mb-1">
              <input
                value={num}
                onChange={(e) => setNum(e.target.value)}
                type="number"
                className="flex-grow bg-transparent border-none outline-none text-white"
                placeholder={translate(getText("请输入保证金金额"))}
              />
              <button
                className="text-primary px-2"
                onClick={() => {
                  setNum(userInfo?.balance?.usdt_available);
                }}
              >
                {translate(getText("全部"))}
              </button>
            </div>
            <div className="text-neutral-500 text-xs">
              {translate(getText("≈"))} {getchangeNum()} CNY
            </div>
          </div>

          <div className="mb-4">
            <div className="text-neutral-400 text-sm mb-2">
              {translate(getText("杠杆倍數"))}
            </div>
            <div className="flex flex-wrap gap-2">{getLeverageNodes()}</div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <div className="text-neutral-400 text-sm mb-2">
                {translate(getText("止盈"))}
              </div>
              <div className="flex flex-wrap gap-2">{getLeverSet2Nodes()}</div>
            </div>
            <div>
              <div className="text-neutral-400 text-sm mb-2">
                {translate(getText("止损"))}
              </div>
              <div className="flex flex-wrap gap-2">{getLeverSet1Nodes()}</div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <div className="text-neutral-400 text-sm mb-1">
                {translate(getText("止盈价"))}
              </div>
              <div className="text-white font-medium">{winPrice || "--"}</div>
            </div>
            <div>
              <div className="text-neutral-400 text-sm mb-1">
                {translate(getText("止损价"))}
              </div>
              <div className="text-white font-medium">{lossPrice || "--"}</div>
            </div>
          </div>

          <div className="mb-4">
            <div className="text-neutral-400 text-sm mb-1">
              {translate(getText("强平价格"))}
            </div>
            <div className="text-white font-medium">{boomPrice || "--"}</div>
          </div>

          <button
            className={`w-full py-3 rounded-lg font-medium text-white mb-4 ${
              num >= minNum && isUse
                ? "bg-primary"
                : "bg-neutral-600 text-neutral-300"
            }`}
            onClick={() => {
              if (num >= minNum && isUse) {
                setIsUse(false);
                buyCoin(
                  {
                    isnew: 1, // 新增
                    coinname: nowTab.toUpperCase() + "/USDT",
                    amount: num,
                    tzfx: type, // 1 多 2 空
                    leverage: bsnum,
                    openprice: coinListData[nowTab]?.close,
                    loss: lossPrice,
                    win: winPrice,
                    boomPrice: boomPrice,
                  },
                  () => {
                    setIsUse(true);
                    setIsShowOrder(false);
                  }
                );
              }
            }}
          >
            {translate(getText("確認下單"))}
          </button>
        </div>
      </div>
    </Popup>
  );
}
